<div class="rootContainer">
    <!--Stage 1-->
    <div class="cardContainer" [hidden]="currentStep != 1">
        <app-registration-content-header [step]="1"></app-registration-content-header>

        <app-enter-phone #enterPhoneComponent
                         submitButtonText="{{ 'Pages.RegistrationByPhone.Step1.SubmitButtonText' | translate }}"
                         [(phoneValueWithRegion)]="phoneValueWithRegion"
                         (submited)="sendCode($event)">
        </app-enter-phone>
    </div>

    <!--Stage 2-->
    <div class="cardContainer" [hidden]="currentStep != 2">
        <app-registration-content-header [step]="2"></app-registration-content-header>

        <app-enter-sms-code #enterSMSCodeComponent
                            submitButtonText="{{ 'Pages.RegistrationByPhone.Step2.SubmitButtonText' | translate }}"
                            [(phoneValueWithRegion)]="phoneValueWithRegion"
                            (resendSMSCode)="sendCode($event)"
                            (submited)="confirmCode($event)">
        </app-enter-sms-code>

        <div class="text-muted">
            <span>
                {{ "Pages.RegistrationByPhone.ConfirmCodeHelpText" | translate }}
            </span>
        </div>
    </div>

    <!--Stage 3-->
    <div class="cardContainer" [hidden]="currentStep != 3">
        <app-registration-content-header [step]="3"></app-registration-content-header>

        <app-enter-new-password #enterNewPasswordComponent
                                submitButtonText="{{ 'Pages.RegistrationByPhone.Step3.SubmitButtonText' | translate }}"
                                (submited)="setNewPassword($event)">
        </app-enter-new-password>
    </div>
</div>
